module.exports = __webpack_public_path__ + "img/corrosion-dataset-sample.6833c73a.jpg";